<template>
  <div class="container">
    <h1>Craniosacrale Energiebalance am Pferd</h1>

    <p>Pferde, als sehr sensible und vegetative Tiere, sprechen besonders gut auf Craniosacrale Energiebalance 
      an und können sich rasch darauf einlassen. Ich erspüre Spannungsassymetrien im Gewebe, die sich über 
      das Fasziensystem des Körpers an ganz anderen Stellen bemerkbar machen können. Man könnte sagen 
      „das Gewebe spricht“ und der Körper leitet mich dorthin, wo er mich braucht. Ich kann dort mittels 
      minimaler Mobilisationstechniken wieder einen harmonischen Energiefluss herstellen.</p>

    <Slider :data="content" />   

    <!-- <img src="../assets/img/schaedel.jpg" width="600" alt="Katharina Herda" /> -->

    <p>Zu meinem ganzheitlichen Blick für die optimale Hilfestellung für ihr Pferd gehört mein Wissen über 
      biomechanische Zusammenhänge ebenso wie zu Hufproblematiken und dem Zusammenspiel zwischen Bindegewebe, 
      Muskeln, Gelenken und dem Lymphsystem.</p>


    <p><b>Bei folgenden Problemstellungen des Pferdes kann sich eine Anwendung als sinnvoll erweisen:</b></p>
    
    <ul class="list">
      <li>Rittigkeitsprobleme, Rücken- und Genickprobleme</li>
      <li>unklare Lahmheiten, Traumalösung</li>
      <li>zur Regeneration nach Unfällen oder Operationen</li>
      <li>zur Unterstützung älterer Pferde</li>
      <li>Fohlen</li>
    </ul>

    <p>Ich empfehle die Pferde am Tag der Anwendung und am darauf folgenden Tag zu schonen, um dem Körper 
      ausreichend Zeit für den Selbstheilungsprozess zu geben.</p>

    <router-link :to="{ path: 'energiebalance#uebersicht' }" class="block margin-tb align-right">zurück zur Übersicht</router-link> 

  </div>
</template>

<script>
import Slider from "./shared/Slider.vue";

export default {
  name: "CranioPferd", //this is the name of the component
   metaInfo() {
        return { 
            title: "Craniosacrale Energiebalance für Pferde - Katharina Herda",
            meta: [
                { name: 'description', content:  'Craniosacrale Energiebalance unterstützt den Körper sich selbst von Schmerzen und Blockaden zu befreien, indem der natürliche Fluss wiederhergestellt wird.'},
                { property: 'og:title', content: "Craniosacrale Energiebalance für Pferde - Katharina Herda"},
                { property: 'og:description', content: 'Craniosacrale Energiebalance unterstützt den Körper sich selbst von Schmerzen und Blockaden zu befreien, indem der natürliche Fluss wiederhergestellt wird.'},    
                { property: 'og:image', content: 'src/img/assets/slider-pferd/wirbelsaele.jpg'},
                { property: 'og:url', content: 'www.herda.at/energiebalance-pferd'}
            ]
        }
    },
    components: {
    "Slider": Slider,
  },
  
  data() { 
    return {
      content: {
        heading: 'Impressionen von der Craniosacralen Energiebalance mit Pferden', 
        slides: [{ className: 'slider-pferd-wirbelsaeule', htmlContent: `<span class="sr-only">Katharina Herda führt eine cranioscrale Anwendung an der Wirbelsäule des Pferde durch</span>`
          }, 
          { className: 'slider-pferd-becken', htmlContent: `<span class="sr-only">Katharina Herda gleicht Spannungen im ISG des Pferdes aus</span>`
          }, 
          { className: 'slider-pferd-genick', htmlContent: `<span class="sr-only">Katharina Herda führt sanfte Regulationen am Genick des Pferdes durch</span>`
          },
          { className: 'slider-pferd-kiefergelenk', htmlContent: `<span class="sr-only">Katharina Herda behandelt das Kiefergelenk des Pferdes</span>`
          },
          { className: 'slider-pferd-schulter', htmlContent: `<span class="sr-only">Katharina Herda löst Verspannungen in der Schulter des Pferdes</span>`
          },
          { className: 'slider-pferd-zungenbein', htmlContent: `<span class="sr-only">Katharina Herda führt sanfte Regulationen am Zungenbein des Pferdes durch</span>`
          }
          
        ]

      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CranioPferd.vue